import apiService from "./BaseApi";

const BASE_SIGNERS_URL = 'signers'

const SignersService = {
    createSigner: async (idEnvelope, signer) => apiService.post(`${BASE_SIGNERS_URL}/${idEnvelope}`, signer),
    getAllSigners: async (idEnvelope) => apiService.get(`${BASE_SIGNERS_URL}/${idEnvelope}`),
    deleteSigner: async (idEnvelope, idSigner) => apiService.delete(`${BASE_SIGNERS_URL}/${idEnvelope}/${idSigner}`),
    updateSignerRequirement: async (idEnvelope, idSigner, requirements) => apiService.put(`${BASE_SIGNERS_URL}/${idEnvelope}/${idSigner}`, requirements)
}

export default SignersService;